/**
 * Real text measurement for the chrome fit — the fit rule protects the
 * space text NEEDS, never an allowance (kit principle: measure need).
 * One shared canvas context, font set per call and memoized per string.
 */

let ctx: CanvasRenderingContext2D | null = null;
const cache = new Map<string, number>();

export function measureChromeText(text: string, font: string): number {
  const key = `${font} ${text}`;
  const hit = cache.get(key);
  if (hit !== undefined) return hit;
  if (!ctx) {
    ctx = document.createElement("canvas").getContext("2d");
    if (!ctx) return 0;
  }
  ctx.font = font;
  const width = ctx.measureText(text).width;
  if (cache.size > 2000) cache.clear();
  cache.set(key, width);
  return width;
}

/** Label band font — must match `.coc-label` in the CSS. */
export const CHROME_LABEL_FONT = '500 14px "DM Sans", system-ui, sans-serif';

/** Foot band font — must match `.coc-foot-text` in the CSS. */
export const CHROME_FOOT_FONT = '400 11px "DM Sans", system-ui, sans-serif';
